import { useEffect, useState } from 'react';

interface FAQModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const faqs = [
  {
    category: '주문·결제',
    icon: 'ri-shopping-cart-2-line',
    items: [
      {
        q: '비회원도 구매할 수 있나요?',
        a: '네, 비회원도 구매 가능합니다. 다만 회원 가입 시 주문 내역 조회, 적립금 적립·사용, 쿠폰 수령 등 다양한 혜택을 누리실 수 있습니다.',
      },
      {
        q: '결제 후 주문 확인은 어디서 하나요?',
        a: '결제 완료 직후 등록하신 이메일로 주문 확인 메일이 발송됩니다. 메일이 오지 않는 경우 스팸함을 확인하시거나, 고객센터(withinderm@naver.com)로 주문자명과 연락처를 알려 주시면 확인해 드립니다.',
      },
      {
        q: '주문 후 취소는 어떻게 하나요?',
        a: '출고 전까지 고객센터(이메일 또는 전화)로 주문번호를 알려 주시면 취소 처리해 드립니다. 이미 출고된 경우에는 수령 후 교환·환불 절차로 진행해 주세요.',
      },
      {
        q: '무통장 입금 시 입금 기한이 있나요?',
        a: '가상계좌 발급 후 24시간 이내에 입금하지 않으시면 주문이 자동 취소됩니다. 입금 시 반드시 주문자 성함과 동일한 이름으로 입금해 주시기 바랍니다.',
      },
      {
        q: '할인 쿠폰과 적립금을 함께 사용할 수 있나요?',
        a: '쿠폰과 적립금은 중복 사용이 불가합니다. 둘 중 하나만 선택하여 적용하실 수 있으며, 결제 화면에서 원하시는 혜택을 선택해 주세요.',
      },
    ],
  },
  {
    category: '배송',
    icon: 'ri-truck-line',
    items: [
      {
        q: '배송은 얼마나 걸리나요?',
        a: '결제 확정 후 1–3 영업일 이내 출고되며, 출고 후 수도권은 1–2 영업일, 지방은 2–3 영업일, 제주·도서산간은 3–5 영업일 내 수령하실 수 있습니다. 주말·공휴일은 영업일에서 제외됩니다.',
      },
      {
        q: '배송비는 얼마인가요?',
        a: '50,000원 이상 구매 시 무료 배송이며, 미만 시 3,000원의 배송비가 부과됩니다. 제주도는 추가 3,000원, 도서·산간 지역은 추가 5,000원이 발생합니다.',
      },
      {
        q: '배송 조회는 어떻게 하나요?',
        a: '출고 완료 시 등록된 이메일·휴대폰으로 송장번호와 배송사 정보가 발송됩니다. 수신하신 정보로 해당 택배사 홈페이지 또는 앱에서 실시간 배송 현황을 조회하실 수 있습니다. 송장 활성화까지 최대 24시간이 소요될 수 있습니다.',
      },
      {
        q: '배송지 변경이 가능한가요?',
        a: '배송지 변경은 출고 전에만 가능합니다. 변경을 원하신다면 즉시 고객센터(withinderm@naver.com / 010-7340-1951)로 연락 주세요. 출고 후에는 배송지 변경이 불가하며, 오입력으로 인한 반송·재배송 비용은 고객 부담입니다.',
      },
    ],
  },
  {
    category: '상품 사용·성분',
    icon: 'ri-leaf-line',
    items: [
      {
        q: 'ZEO 지오라이트는 어떻게 사용하나요?',
        a: 'ZEO ZEOLITE는 Food Detox, Beauty, Wellness 세 가지 방식으로 활용할 수 있습니다.\n\n【Food Detox】\n· 과일·채소·견과류 세척: 물 1L당 파우더 2스푼을 넣고 20분 담근 후 흐르는 물로 헹굽니다.\n· 쌀 세척: 물 1L당 파우더 2스푼에 쌀을 30분 담근 후 깨끗이 헹궈 조리합니다.\n\n【Beauty】\n· Face Detox Mask: 지올라이트와 물을 3:1 비율로 섞어 페이스트를 만들고 얼굴에 바른 후 15분 뒤 세안합니다.\n· Body Scrub: 코코넛 오일·설탕·지올라이트를 1:1 비율로 섞어 젖은 피부에 마사지 후 씻어냅니다.\n· Natural Deodorant: 건조한 겨드랑이에 파우더를 소량 직접 사용하거나 코코넛 오일과 섞어 샤워 15분 전에 바릅니다.\n\n【Wellness】\n· Detox Bath: 욕조에 1/4~1/2컵의 파우더를 넣고 20~30분 몸을 담근 후 깨끗한 물로 헹굽니다.',
      },
      {
        q: '크로아티아 원산지 제품인가요?',
        a: '네, 위딘의 ZEO 지오라이트는 크로아티아의 청정 자연에서 채취된 클리노프틸로라이트 원석을 사용합니다. VEN 특허 기술로 처리된 프리미엄 원료를 엄격한 품질 기준 하에 국내에서 가공·패키징합니다.',
      },
      {
        q: '유통기한이 있나요?',
        a: '제품 포장 하단 또는 측면에 유통기한이 표기되어 있습니다. 개봉 후에는 직사광선과 고온 다습한 환경을 피하여 서늘하고 건조한 곳에 밀봉 보관해 주세요. 개봉 후 가능한 빠르게 사용하시길 권장합니다.',
      },
      {
        q: '임산부·수유부·어린이도 사용할 수 있나요?',
        a: '임산부·수유부·영유아·어린이는 사용 전 반드시 전문 의사나 약사와 상담하신 후 사용 여부를 결정해 주세요. 당사는 해당 대상에 대한 안전성을 별도로 보증하지 않습니다.',
      },
    ],
  },
  {
    category: '교환·환불',
    icon: 'ri-refresh-line',
    items: [
      {
        q: '교환·환불 신청은 어떻게 하나요?',
        a: '고객센터 이메일(withinderm@naver.com) 또는 전화(010-7340-1951)로 ① 주문번호 ② 사유 ③ 불량인 경우 사진을 첨부하여 접수해 주세요. 접수 확인 후 회수 방법 및 처리 절차를 안내드립니다.',
      },
      {
        q: '환불은 얼마나 걸리나요?',
        a: '반품 상품 회수 및 검수 완료 후 영업일 기준 3–5일 이내 환불 처리됩니다. 신용카드는 카드사 정책에 따라 최대 7일, 계좌이체는 3영업일 이내, 적립금은 즉시 반환됩니다.',
      },
      {
        q: '개봉한 상품도 환불 가능한가요?',
        a: '단순 변심에 의한 개봉 상품은 환불이 제한됩니다. 단, 상품 자체 불량·파손·오배송의 경우에는 개봉 여부와 관계없이 수령 후 30일 이내 교환·환불이 가능합니다.',
      },
      {
        q: '반품 배송비는 누가 부담하나요?',
        a: '단순 변심 반품의 경우 왕복 배송비(편도 3,000원 × 2 = 6,000원)는 고객 부담입니다. 상품 불량·오배송의 경우에는 당사가 전액 부담하며, 선불 반송 레이블을 발송해 드립니다.',
      },
    ],
  },
];

export default function FAQModal({ isOpen, onClose }: FAQModalProps) {
  const [openIndex, setOpenIndex] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const toggleItem = (key: string) => {
    setOpenIndex((prev) => (prev === key ? null : key));
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg mx-4 overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-[#F7F4F0] px-8 pt-8 pb-6 relative">
          <button
            onClick={onClose}
            className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center rounded-full bg-black/10 hover:bg-black/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-[#3D2B1F] text-lg"></i>
          </button>
          <p className="text-xs font-medium tracking-widest text-[#8B7355] uppercase mb-2">FAQ</p>
          <h2 className="text-2xl font-bold text-[#3D2B1F]">자주 묻는 질문</h2>
        </div>

        {/* Body */}
        <div className="px-8 py-7 max-h-[60vh] overflow-y-auto space-y-6">
          {faqs.map((section) => (
            <div key={section.category}>
              {/* 카테고리 헤더 */}
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${section.icon} text-[#8B7355] text-lg`}></i>
                </div>
                <h3 className="text-base font-semibold text-[#3D2B1F]">{section.category}</h3>
              </div>

              {/* 질문 목록 */}
              <div className="pl-8 space-y-2">
                {section.items.map((item, idx) => {
                  const key = `${section.category}-${idx}`;
                  const isOpen = openIndex === key;
                  return (
                    <div key={key} className="border border-[#EDE8E0] rounded-xl overflow-hidden">
                      <button
                        onClick={() => toggleItem(key)}
                        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-[#F7F4F0] transition-colors duration-200 cursor-pointer"
                      >
                        <span className="text-sm font-medium text-[#3D2B1F] pr-4 leading-snug">{item.q}</span>
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i
                            className={`ri-arrow-down-s-line text-[#8B7355] text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                          ></i>
                        </div>
                      </button>
                      {isOpen && (
                        <div className="px-4 pb-4 pt-1 bg-[#F7F4F0]">
                          <p className="text-sm text-[#5C4A3A] leading-relaxed whitespace-pre-line">{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* 구분선 (마지막 제외) */}
              {section.category !== faqs[faqs.length - 1].category && (
                <div className="border-t border-[#EDE8E0] mt-5"></div>
              )}
            </div>
          ))}

          {/* 추가 문의 안내 */}
          <div className="flex items-start gap-3 bg-[#8B7355]/10 rounded-xl px-4 py-4">
            <i className="ri-customer-service-2-line text-[#8B7355] text-lg mt-0.5 flex-shrink-0"></i>
            <div>
              <p className="text-sm font-semibold text-[#3D2B1F] mb-1">더 궁금한 점이 있으신가요?</p>
              <p className="text-xs text-[#8B7355] leading-relaxed mb-1">
                고객센터로 문의 주시면 평일 10:00–17:00 내 신속히 답변드리겠습니다.
              </p>
              <p className="text-xs text-[#8B7355]">📧 withinderm@naver.com &nbsp;|&nbsp; 📞 010-7340-1951</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-8 py-5 border-t border-[#EDE8E0]">
          <button
            onClick={onClose}
            className="w-full bg-[#8B7355] text-white text-sm font-medium py-3 rounded-xl hover:bg-[#7A6245] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
